import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenMaterialDeleteAction from './communityGardenMaterialDelete.action.json' with { type: 'json' }
import { communityGardenMaterialObject } from '../../communityGardenMaterialObject'

const communityGardenMaterialDeleteDefinition = defineAction({
  ...communityGardenMaterialDeleteAction,

  input: z.object({ id: communityGardenMaterialObject.shape.id }),
  output: z.object({}),
})

export default communityGardenMaterialDeleteDefinition
